import script from "./EventSettingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSettingsView.vue?vue&type=script&setup=true&lang=js"

import "./EventSettingsView.vue?vue&type=style&index=0&id=61dcc84d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61dcc84d"]])

export default __exports__